export const getSchedulingAssistantSettingValueByName = (schedulingAssistantSettings, settingName) => {
  const safeSchedulingAssistantSettings = Array.isArray(schedulingAssistantSettings) ? schedulingAssistantSettings : []
  return safeSchedulingAssistantSettings.find((setting) => setting.settingName === settingName)?.settingValue
}
